export default "__VITE_ASSET__BAEqhZq1__"